import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CatalogueService } from 'src/app/lib/services/catalouge.service';
import { CommonService } from 'src/app/lib/services/common.service';
import { StorageService } from 'src/app/lib/services/storage.service';
import { UserService } from 'src/app/lib/services/user.service';
import { Constants } from 'src/app/config/constants';
import { InfiniteScrollCustomEvent } from '@ionic/angular';

@Component({
  selector: 'app-b2b-storelisting',
  templateUrl: './b2b-storelisting.component.html',
  styleUrls: ['./b2b-storelisting.component.scss'],
  standalone: false
})

export class B2bStorelistingComponent implements OnInit {
  categoryId: string;
  merchantListArray = [];
  filtermerchantListArray = [];
  favShops = new Set();
  flag: any;
  currentAddress: any = this.storageService.getItem(Constants.USER_LOCATION) ? this.storageService.getItem(Constants.USER_LOCATION) : '';
  distanceFilter: any

  constructor(
    private route: ActivatedRoute,
    private catalogueService: CatalogueService,
    private router: Router,
    public commonservice: CommonService,
    private userService: UserService,
    private storageService: StorageService
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    if (this.router.url.includes("favourites")) {
      this.categoryId = 'favourites';
    } else {
      this.route.params.subscribe((params) => {
        this.categoryId = params['id'];
      });
    }
    this.getStoreListing();
  }

  /**
   * @name getStoreListing
   * @type Function - Get all stores from backend
   * **/
  async getStoreListing() {
    const loading = await this.commonservice.presentLoader();
    loading.present();
    try {
      const res = await this.catalogueService.getmerchantListArrayWithLatLon(this.currentAddress.lat, this.currentAddress.lon, this.categoryId, 200);
      if (res && res['data'].message) {
        loading.dismiss();
        return this.commonservice.toast(res['data'].message)
      }
      if (res && res['data']) {
        loading.dismiss();
        this.merchantListArray = res['data']?.stores;
        this.merchantListArray?.length ? this.flag = false : this.flag = true;
        // Filtering out duplicate shops before pushing
        // const newMerchants = this.merchantListArray.filter((merchant: any) =>
        //   !this.filtermerchantListArray.some((existingMerchant: any) => existingMerchant.shop_id === merchant.shop_id)
        // );
        this.filtermerchantListArray = this.merchantListArray;
      } else {
        this.commonservice.danger(`Stores list isn't returned from api`);
      }
    } catch (error) {
      console.error(error);
      loading.dismiss();
      this.commonservice.toast(error.error?.error?.message);
    }
  }

  favouriteShop(event: any) {
    let shop_id = event.shop_id;
    let isFavourite = event.isFavourite;
    this.commonservice.presentProgressBarLoading();
    let string = String(shop_id);
    this.userService.addFavourite({ shopId: string }).subscribe(res => {
      this.commonservice.closeProgressBarLoading();
      if (isFavourite) {
        event.shop.isFavourite = false;
        this.commonservice.danger('Shop removed from favourites.')
      } else {
        event.shop.isFavourite = true;
        this.commonservice.success('Shop added to favourites.');
      }
    }, (error: any) => {
      this.commonservice.closeProgressBarLoading();
      this.commonservice.toast(error.error.error.message);
    })
  }
}